import React, { useRef } from "react";
import Styles from "./BaseModal.styled";

const BaseModal = ({
  showModal,
  setShowModal,
  title,
  children,
  maxWidth50,
  maxWidth500,
  width,
  slim = false,
}) => {
  const modalRef = useRef();

  return (
    <>
      {showModal ? (
        <Styles.Background ref={modalRef}>
          <Styles.ModalWrapper
            slim={slim}
            showModal={showModal}
            width={width}
            maxWidth50={maxWidth50 ? true : false}
            maxWidth500={maxWidth500 ? true : false}
          >
            <Styles.CloseModalButton
              aria-label="Close modal"
              onClick={() => setShowModal((prev) => !prev)}
            />
            <Styles.ModalContent>
              <Styles.Title>{title}</Styles.Title>
              {children}
            </Styles.ModalContent>
          </Styles.ModalWrapper>
        </Styles.Background>
      ) : null}
    </>
  );
};

export default BaseModal;
